
import { PolymerElement, html } from '@polymer/polymer';

import { PropertyAccessors } from '@polymer/polymer/lib/mixins/property-accessors';

class COMHtml extends PropertyAccessors(HTMLElement) {
  static get is() {return 'com-html';}
  static get observedAttributes() { return ['value']; }
  connectedCallback() {
    this._enableProperties();
    /**
     * Note for ShadyCSS
     * @see https://github.com/webcomponents/shadycss/
     * @see https://github.com/Polymer/polymer/blob/b124b707b497f1e592db7d85c5e64893402641b8/lib/mixins/element-mixin.html#L587
     * We need to call render AFTER _enableProperties so that the styling shim is applied to the HTML content
     */
    this._render();
  }

  /**
   * @desc santize html string
   * @param {String} input html
   * @todo add sanitize functionality
   * @return {String} sanitized html
   */
  sanitize(value) {
    return value;
  }
  /**
   * @desc Property Accessors from Polymer.PropertyAccessors
   * @param {Object} currentProps
   * @param {Object} changedProps
   * @param {Object} oldProps
   */
  _propertiesChanged(currentProps, changedProps, oldProps) {
    if ('value' in changedProps) {
      this._render();
    }
  }
  /**
   * @desc Update innerHTML
   */
  _render() {
    let value = this.value;
    if (value) {
      const atts = this.attributes;
      for (let i = 0; i < atts.length; i++) {
        // apply angular name space onto div and span elements for component level styling
        if (atts[i].nodeName.indexOf('_ngcontent') === 0) {
          value = this.value.replace(/(<([a-z]+[1-6]*))([ >])/g, '$1 ' + atts[i].nodeName + '$3')
        }
      }
    }
    this.innerHTML = value || '';
  }
}
COMHtml.createPropertiesForAttributes();
window.customElements.define(COMHtml.is, COMHtml);